<!--
    描述：人员管理--人员列表
    时间：2020-04-23
    Created by zwh
-->
<template>
	<div class="h100">
		<div class="w-table-layout">
			<div class="w-table-content"
				 ref="usersContent">

				<el-table :data="tableObj.tableData"
						  row-key="id"
						  v-loading="tableObj.loading"
						  ref="tableObj"
						  default-expand-all
						  :height="tableObj.tableH"
						  border
						  highlight-current-row>
					<el-table-column type="index"
									 align="center"
									 width="50"></el-table-column>
					<el-table-column prop="btnName"
									 align="center"
									 label="按钮名称"
									 show-overflow-tooltip
									 min-width="120"></el-table-column>
					<el-table-column prop="alias"
									 label="别名"
									 align="center"
									 show-overflow-tooltip
									 min-width="120"></el-table-column>
					<el-table-column label="操作"
									 align="center"
									 show-overflow-tooltip
									 min-width="80">
						<template slot-scope="scope">
							<el-button size="mini"
									   icon="el-icon-edit"
									   title="编辑"
									   type="text"
                                       v-if="roleBtns.includes('btn_edit')"
									   @click="doClick(scope.row,'edit')"></el-button>
							<el-button v-if="!scope.row.children && roleBtns.includes('btn_delete')"
									   size="mini"
									   icon="el-icon-delete"
									   title="删除"
									   type="text"
									   @click="doClick(scope.row,'delete')"></el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<!-- 新增、编辑等弹窗 -->
		<el-dialog :title="dialogObj.title"
				   :visible.sync="dialogObj.visible"
				   :width="dialogObj.width"
				   center
				   :close-on-click-modal="false"
				   @closed="handleClose">
			<!-- 弹窗组件 -->
			<addBtn ref="addBtn"
					v-if="dialogObj.visible"
					:mode="dialogObj.mode"
					:transObj="transObj"
					@handle-success="handleSuccess"></addBtn>
			<!-- footer 组件 -->
			<div slot="footer"
				 class="dialog-footer text-center"
				 v-if="dialogObj.mode !== 'view'">
				<el-button size="small"
						   @click="handleClose">取 消</el-button>
				<el-button type="primary"
						   size="small"
						   :loading="btnLoading"
						   @click="doSave">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import addBtn from './add_btn_dialog'
import {
	selectAll,
	deleteById,
	getBtnsByMenuId
} from 'api/system/menuBtn.js'

export default {
	components: { addBtn },
	data() {
		return {
		    //子组件传递对象
			transObj: {
				id: '',         //id
				menuId: '',     //菜单id
				menuName: '',   //菜单名称
				mode: ''
			},
			btnLoading: false,
			dialogObj: {
				title: '',      //弹框标题
				visible: false, //弹框是否显示
				width: '650px', //弹框宽度
				mode: 'add'     //弹框模式 add:新增
			},
			//表格对象
			tableObj: {
				loading: false,
				tableH: 400,    //高度
				tableData: [],  //数据源
				currentPage: 1, //分页信息
				pageSize: 10,
				total: 0,
				pageList: [10, 20, 50, 100] // 显示条数数组
			}
		}
	},
	methods: {
	    //初始方法：获取菜单按钮信息
		initMenuBtnInfo(obj) {
			//赋值菜单信息
			this.transObj = obj
			//查询按钮信息
			this.getMenuBtnTableList()
		},
		//获取菜单按钮信息
		getMenuBtnTableList() {
			let that = this
			let param = {
				menuId: this.transObj.menuId
			}
			getBtnsByMenuId(param).then(res => {
				if (res.operationCode == 1) {
					that.tableObj.tableData = res.data
				}
			})
		},
		//新增、修改、删除等操作按钮点击事件
		doClick(obj, type) {
			this.dialogObj.mode = type
			if (type === 'add') {   //新增
				this.transObj.id = ''
				this.dialogObj.title = '新增按钮'
				this.dialogObj.visible = true
			} else if (type === 'edit') {   //编辑
				this.transObj.id = obj.id
				this.dialogObj.title = '编辑按钮'
				this.dialogObj.visible = true
			} else if (type === 'delete') { //删除
				this.delete(obj)
			}
		},
		//删除
		delete(obj) {
			let that = this
			this.$confirm('确认删除吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let param = { id: obj.id }
				deleteById(param).then(res => {
					if (res.operationCode == 1) {
						that.$message({ message: '删除成功', type: 'success' })
						that.getMenuBtnTableList()
					} else {
						that.$message({ message: res.msg, type: 'error' })
					}
				})
			})
		},
		// 关闭弹窗事件
		handleClose() {
			this.dialogObj.visible = false
		},
		// 确定按钮事件
		doSave() {
			this.$refs.addBtn.doSave()
		},
		// 切换显示条数
		handleSizeChange(val) {},
		// 切换当前页码
		handleCurrentChange(cur) {},
		//成功回调处理
		handleSuccess() {
			this.dialogObj.visible = false
			this.getMenuBtnTableList()
		}
	},
	mounted() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.tableObj.tableH = this.$refs.usersContent.offsetHeight
			}, 100)
		})
	},
	// 进入缓存页面
	activated() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.tableObj.tableH = this.$refs.usersContent.offsetHeight
			}, 100)
		})
	},
	computed: {
		...mapState('app', { clientSize: state => state.clientSize }),
		...mapState('menu', {
			roleBtns: state => state.roleBtns
		})
	},
	watch: {
		clientSize(val) {
			this.tableObj.tableH = this.$refs.usersContent.offsetHeight
		}
	}
}
</script>
<style lang="less">
</style>
